/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updates_Updatenow1Inputs */

const tr_updates_updatenow1 = /** @type {(inputs: Updates_Updatenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Güncelle`)
};

const en_updates_updatenow1 = /** @type {(inputs: Updates_Updatenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Now`)
};

/**
* | output |
* | --- |
* | "Update Now" |
*
* @param {Updates_Updatenow1Inputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
const updates_updatenow1 = /** @type {((inputs?: Updates_Updatenow1Inputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updates_Updatenow1Inputs, { locale?: "tr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_updates_updatenow1(inputs)
	return en_updates_updatenow1(inputs)
});
export { updates_updatenow1 as "updates_updateNow" }